module.exports = __webpack_public_path__ + "media/images/background_approach-231b2279f238edb2940d22895adb946c.jpg";